module.exports = __webpack_public_path__ + "img/80160651.7896957f.png";